import { render } from "./Newsletter.vue?vue&type=template&id=a9ff5924&scoped=true"
import script from "../js/newsletter.js?vue&type=script&lang=js"
export * from "../js/newsletter.js?vue&type=script&lang=js"

import "./Newsletter.vue?vue&type=style&index=0&id=a9ff5924&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/platinum-landscape/platinum-landscape-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9ff5924"]])

export default __exports__